import { useSelector } from "react-redux";
import { AppStore } from "../../store";
import { WisrProfile } from "./wisr-profile";

export const useGetWisrProfile = () => {
  return useSelector<AppStore, WisrProfile | undefined>(
    (store) => store.wisrProfileState.profile
  );
};
